//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
export default {
  name: "InspectionTemplatePointModal",
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: "巡检模板点位管理表单",
      tableName: "om_inspection_template_point",
      form_fields: ['parentId', 'templateId', 'name', 'remark', 'coordinate', 'path', 'status', 'delFlag', 'sort'],
      form_fields_time: [],
      validatorRules: {
        parentId: {
          rules: [{
            required: true,
            message: '请输入父级id!'
          }]
        },
        templateId: {
          rules: [{
            required: true,
            message: '请输入模板id!'
          }]
        },
        name: {
          rules: [{
            required: true,
            message: '请输入巡检点名称!'
          }]
        },
        delFlag: {
          rules: [{
            required: true,
            message: '请输入删除状态!'
          }]
        }
      }
    };
  },
  props: ['pagePath'],
  created: function created() {},
  methods: {}
};